export default __webpack_public_path__ + "static/media/es.e19421bf.png";